var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeaturesCardArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.999926 8.00067C0.734729 8.00067 0.480394 7.89532 0.292872 7.7078C0.105349 7.52028 3.17604e-07 7.26594 3.06012e-07 7.00074C2.9442e-07 6.73555 0.105349 6.48121 0.292872 6.29369C0.480394 6.10617 0.734729 6.00082 0.999926 6.00082L20.5845 6.00082L16.2908 1.70914C16.103 1.52138 15.9975 1.26672 15.9975 1.00119C15.9975 0.735657 16.103 0.481 16.2908 0.293241C16.4785 0.105481 16.7332 -7.31432e-07 16.9987 -7.43038e-07C17.2643 -7.54645e-07 17.5189 0.105481 17.7067 0.293241L23.7062 6.29279C23.7994 6.38568 23.8732 6.49602 23.9236 6.6175C23.9741 6.73898 24 6.86922 24 7.00074C24 7.13227 23.9741 7.2625 23.9236 7.38398C23.8732 7.50546 23.7994 7.61581 23.7062 7.70869L17.7067 13.7082C17.5189 13.896 17.2643 14.0015 16.9987 14.0015C16.7332 14.0015 16.4785 13.896 16.2908 13.7082C16.103 13.5205 15.9975 13.2658 15.9975 13.0003C15.9975 12.7348 16.103 12.4801 16.2908 12.2923L20.5845 8.00067L0.999926 8.00067Z",
    fill: "url(#paint0_linear_1_121)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_121",
    x1: 4.96712e-7,
    y1: 7.00075,
    x2: 31.9976,
    y2: 7.00075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29ABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA14F0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesCardArrow);
export default __webpack_public_path__ + "static/media/features_card_arrow.686c0389dcb453e5f3f046700617258a.svg";
export { ForwardRef as ReactComponent };